import {
  ADD_FAMILY_USER_ROLE,
  DELETE_FAMILY_USER_ROLE,
  FamilyUserRolesState,
  INITIAL_STATE,
  QUERY_FAMILY_USER_ROLES,
  UPDATE_FAMILY_USER_ROLE,
} from './types';

export const familyUserRolesReducer = (
  state: FamilyUserRolesState = INITIAL_STATE,
  { type, payload }: any
): FamilyUserRolesState => {
  switch (type) {
    case QUERY_FAMILY_USER_ROLES:
      return {
        familyUserRoles: payload,
      };
    case DELETE_FAMILY_USER_ROLE:
      return {
        familyUserRoles: state.familyUserRoles.filter((role) => role._id !== payload),
      };
    case ADD_FAMILY_USER_ROLE:
      return {
        familyUserRoles: [...state.familyUserRoles, payload],
      };
    case UPDATE_FAMILY_USER_ROLE:
      return {
        familyUserRoles: [
          ...state.familyUserRoles.map((role) => {
            if (role._id === payload.roleId) {
              return payload.updated;
            }
            return role;
          }),
        ],
      };
    default:
      return state;
  }
};
